import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CssTransition from "./css-transition";
import SearchForm from "../search-form";
import useDebounce from "../../Hook/useDebounce";
import { filter } from "underscore";
import { useSelector } from "react-redux";
import Highlighter from "react-highlight-words";
import { ApiCall, sanitizeInput } from "../../utils";

function ModalSearch({ id, searchId, modalOpen, setModalOpen }) {
  const modalContent = useRef(null);
  const searchInput = useRef(null);
  // Search functionality
  const [searchText, setSearchText] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [resultlen, setResultLen] = useState([]);
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);
  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!modalOpen || modalContent.current.contains(target)) return;
      setFilterData([]);
      setModalOpen(false);
      setSearchText("");
      setResultLen([]);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!modalOpen || keyCode !== 27) return;
      setFilterData([]);
      setModalOpen(false);
      setSearchText("");
      setResultLen([]);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  // useEffect(() => {
  //   modalOpen && searchInput.current.focus();
  // }, [modalOpen]);

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  useEffect(() => {
    if (debouncedHandleSearch !== "") handleGlobalSearch(debouncedHandleSearch);
    else if (resultlen > 0) setResultLen([]);
  }, [debouncedHandleSearch]);

  const handleGlobalSearch = async (query) => {
    try {
      const result = await ApiCall.post(
        "/master/global_search",
        {
          search: query,
        },
        token
      );
      setFilterData(result.data);
      setResultLen(result.data.length);
    } catch (err) {}
  };
  return (
    <>
      {/* Modal backdrop */}
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      {/* Modal dialog */}
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-start top-20 mb-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white max-w-2xl w-4/12 max-h-full rounded-xl shadow-lg"
        >
          {/* Search form */}
          <form>
            <div className="relative my-5">
              <h4 className="font-semibold text-center">Search</h4>
              <p className="text-xs text-center">
                Please enter any booking related information
              </p>
              <p className="text-xs text-center mb-5">
                and we will find the matching results.
              </p>
              <SearchForm
                formClass="mx-7"
                inputclass={true}
                value={searchText}
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  setSearchText(value);
                }}
              />
              <br />
              <div className="flex justify-between border-t border-slate-200 px-7 py-1 text-sm font-semibold bg-sky-50">
                <span>Results</span>
                {resultlen > 0 && <span> {resultlen} results found</span>}
              </div>
              <div className="h-64 overflow-auto">
                {debouncedHandleSearch && filterData?.length > 0
                  ? filterData?.map((item) => {
                      return (
                        <div
                          className="px-7 my-4 cursor-pointer"
                          onClick={(e) => {
                            navigate(
                              `/todo/performance/${item.activity_assignment_id}`
                            );
                            setModalOpen(false);
                            setFilterData([]);
                            setSearchText("");
                            setResultLen([]);
                          }}
                        >
                          <h6 className="font-bold text-sm">
                            <Highlighter
                              highlightClassName="YourHighlightClass"
                              searchWords={[searchText]}
                              autoEscape={true}
                              highlightStyle={{ background: "#bae6fd" }}
                              textToHighlight={item.booking_name}
                            />
                          </h6>
                          <div className="text-sm">
                            {item.label}:
                            <span className="pl-1">
                              <Highlighter
                                highlightClassName="YourHighlightClass"
                                searchWords={[searchText]}
                                autoEscape={true}
                                highlightStyle={{ background: "#bae6fd" }}
                                textToHighlight={item.value}
                              />
                            </span>
                          </div>
                        </div>
                      );
                    })
                  : //   <p className="text-sm px-7 py-1">No result found...</p>
                    null}
              </div>
              <br />
              <div className="flex justify-center">
                <button
                  className="absolute bottom-0 bg-slate-100 px-10 py-1 text-sm shadow-sm cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    setModalOpen(false);
                    setFilterData([]);
                    setSearchText("");
                    setResultLen([]);
                  }}
                >
                  Close
                </button>
              </div>
              {/* <label htmlFor={searchId} className="sr-only">
                Search
              </label> */}

              {/* <input
                id={searchId}
                className="w-full border-0 focus:ring-transparent placeholder-slate-400 appearance-none py-3 pl-10 pr-4"
                type="search"
                placeholder="Search Anything…"
                ref={searchInput}
              /> */}
              {/* <button
                className="absolute inset-0 right-auto group"
                type="submit"
                aria-label="Search"
              >
                <svg
                  className="w-4 h-4 shrink-0 fill-current text-slate-400 group-hover:text-slate-500 ml-4 mr-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                  <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                </svg>
              </button> */}
            </div>
          </form>
        </div>
      </CssTransition>
    </>
  );
}

export default ModalSearch;
